const get = require('lodash/get')
export default {
  api: get(process.env, 'VUE_APP_MICROSERVICE_API_SHOPS', '')
}
